const getShowtime = (string, locale, timezone, debug, before = "", after = "") => {
    let transString = 'Error';

    if (string && locale && timezone) {

        const showtimeOptions = {
            hour: "2-digit",
            minute: "2-digit",
            timeZone: timezone
        };

        const dateObject = new Date(string);
        transString = dateObject.toLocaleTimeString(locale, showtimeOptions);
    } else {
        translationErrorLog(debug, 'Time string, locale and timezone are required to display showtime');
    }

    if (before) {
        transString = before + transString;
    }

    if (after) {
        transString = transString + after;
    }

    return transString;
};

const translationErrorLog = (debug, msg) => {
    if(debug) {
        console.error('TRANSLATION TIME ERROR: ' + msg)
    }
}


export default getShowtime
